/**
 * 指挥端：任务/任务组「记录轨迹」→ 单兵 mission_record_tracks + allow_track_fetch
 * POST /api/tracker/tracks/mission-record
 */
import apiFetch from '../apiFetch';
import { collectVoicePttTargets } from './missionVoicePtt';
import { membersInRecordTrackScope, missionWantsRecordTracks } from './missionsModel';

export { collectVoicePttTargets as collectTrackRecordTargets };
export { membersInRecordTrackScope, missionWantsRecordTracks };

export async function setMissionRecordTracks({ allow, deviceUniqueIds = [], names = [], missionId = null } = {}) {
  const device_unique_ids = (deviceUniqueIds || []).map((x) => String(x || '').trim()).filter(Boolean);
  const nameList = (names || []).map((x) => String(x || '').trim()).filter(Boolean);
  if (!device_unique_ids.length && !nameList.length) {
    return { success: true, updated_count: 0, skipped: true };
  }
  const body = {
    allow: Boolean(allow),
    device_unique_ids,
    names: nameList
  };
  if (missionId) body.mission_id = String(missionId).trim();
  const res = await apiFetch('/api/tracker/tracks/mission-record', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const err = new Error(data.error || data.message || `HTTP ${res.status}`);
    err.code = data.code;
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/**
 * Map history/location_history rows into realtime track points { lat, lng, timestamp, ... }.
 */
export function historyRowsToTrackPoints(rows = []) {
  const list = Array.isArray(rows) ? rows : [];
  const out = [];
  list.forEach((r) => {
    const lat = Number(r.latitude ?? r.lat);
    const lng = Number(r.longitude ?? r.lng ?? r.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    if (lat === 0 && lng === 0) return;
    const ts = r.recorded_at || r.timestamp || r.time;
    out.push({
      lat,
      lng,
      timestamp: ts ? new Date(ts).toISOString() : new Date().toISOString(),
      accuracy: r.accuracy != null ? Number(r.accuracy) : null,
      speed: r.speed != null ? Number(r.speed) : null,
      bearing: r.bearing != null ? Number(r.bearing) : null,
      session_id: r.track_session_id || r.session_id || '',
      track_session_id: r.track_session_id || r.session_id || '',
      recorded_at: ts
    });
  });
  return out;
}

/**
 * Fetch recent location_history for a member (fills gaps after reconnect when app batch uploaded).
 */
export async function fetchRecentHistoryTrackPoints(member, minutes = 180) {
  const id = member?.device_unique_id ? String(member.device_unique_id).trim() : '';
  const name = member?.name ? String(member.name).trim() : '';
  const qs = new URLSearchParams({ mode: 'recent', minutes: String(Math.max(15, Number(minutes) || 180)) });
  if (id) qs.set('device_unique_id', id);
  else if (name) qs.set('name', name);
  else return [];
  try {
    const res = await apiFetch(`/api/history/track?${qs.toString()}`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return [];
    return historyRowsToTrackPoints(data.track || data.tracks || []);
  } catch (_) {
    return [];
  }
}